export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/DxfViewer.worker.3ec640e6.js");
}
